import React, { useEffect, useState, useRef } from "react";
import "echarts-gl";
import * as echarts from 'echarts';
import PageHeader from "../../components/PageHeader.js";
import {getLastSession,getLastUser,getDashboardInfo,setDashboardInfo,getCurrentDeviceSerial,setCurrentDeviceSerial} from '../../Data/SessionData.js';
import { createSession, loginUser, dashboardData, resetDevice } from '../../RestUtil.js';
import { chartOption3, chartOption4 } from "../../Data/DemographicData.js";
import SwitchBordCard from "../../components/SwitchBordCard.js";

export default function ElevatorStatus(props) {

  const timer = 0;
  const [graphMode, setGraphMode] = useState("Live");    
  const [sessionInfo, setSessionInfo] = useState(null);    
  const [timerId, setTimerId] = useState(0);    
  const [timerList, setTimerList] = useState([]);    
  const [dashData1, setDashData1] = useState(null);    
  const [buttonsIndoor, setButtonsIndoor] = useState([{title: "BRAKE STATUS",switch: false,}]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [deviceSerial, setDeviceSerial] = useState("");
  const [currDeviceSerial, setCurrDeviceSerial] = useState(getCurrentDeviceSerial);

  useEffect(() => {
    setSessionInfo( getLastSession() );
    var profileData = getLastUser();
    if (profileData != null) {
        setDeviceSerial(profileData.deviceSerial);
    }
    var dashData2 = getDashboardInfo();
    console.log("BE Data from ElevatorStatus", dashData2);
    setDashData1( dashData2 );
  }, []);

  useEffect(() => {
    if (timerId <= 0) return;
    console.log("timer item being newly added  = ",timerId);
    timerList.push(timerId);
    console.log("timer List after push = ",timerList);
    if (timerList.length > 1) {
       var itemToDelete = timerList.shift();
       console.log("timer List after shift = ",timerList);
       console.log("timer shifted item = ",itemToDelete);
       if (itemToDelete !== timerId) {
          clearInterval(itemToDelete);
          console.log("Now cleared timer with id ",itemToDelete);
       }
    }
    // console.log("timer Item newly added "+timerId+" being deleted "+itemToDelete);
  }, [timerId]);

  const deviceSerialChanged = (newSerial) => {
    console.log("Device Serial changed detected3 in Dashboard",newSerial);
    setCurrentDeviceSerial(newSerial);
    setCurrDeviceSerial(newSerial);
    setTimerToPullBEData(newSerial);
  }

  function setTimerToPullBEData(newSerial) {
    const intervalId = setInterval(() => {
      console.log("ElevatorStatus timer-id = "+intervalId,"refreshing every 3 seconds (Live)");
      pullBEData('Live',newSerial);
    }, 3000); // Update every 3 seconds
    setTimerId(intervalId);
    console.log("Set new timer with id",intervalId);
  }

  function pullBEData(modeStr,newSerial) {
    var sessionData = getLastSession();
    console.log("pullBEData invoked with",modeStr);
    dashboardData(sessionData.id,modeStr,newSerial).then(resp => {
      // console.log("dashboard resp",resp);
      setDashboardInfo(resp);
      var dashData2 = getDashboardInfo();
      // console.log("pullBEData", dashData2);
      setDashData1( dashData2 );  
    })
    .catch(err2 => {
      console.log("dashboard failed",err2);          
    });
  }

  useEffect(() => {
    if (dashData1 == null) return;
    var temp1 = [...buttonsIndoor];
    temp1[0].switch = (dashData1.brakeStatus === "OPEN");
    // console.log("Brake Status from BE",dashData1.brakeStatus);
    console.log("latestCTBMETemps",dashData1.latestCTBMETemps);
    console.log("latestCTMotorTemps",dashData1.latestCTMotorTemps);
    setButtonsIndoor(temp1);
    chartPlace();
  }, [dashData1])

  function deleteLastTimer() {
    if (timerList.length > 0) {
        var itemToDelete = timerList.shift();
        console.log("timer List after shift = ",timerList);
        console.log("timer shifted item = ",itemToDelete);
        if (itemToDelete > 0) {
          clearInterval(itemToDelete);
          console.log("Now cleared timer with id ",itemToDelete);
        }
    }
  }

  useEffect(() => {
    if (graphMode == null) return;
    console.log("Graph Mode is changed to",graphMode);
    if (graphMode === "Live") {
        console.log("Now setting-up timer again");
        setTimerToPullBEData(currDeviceSerial);
    }
    else
    if (graphMode === "Weekly") {
      console.log("Now processing Weekly");
      deleteLastTimer();
      setTimerId(0);
      pullBEData(graphMode,currDeviceSerial);
    }
    else
    if (graphMode === "Days15") {
      console.log("Now processing Days-15");
      deleteLastTimer();
      setTimerId(0);
      pullBEData(graphMode,currDeviceSerial);
    }
    else
    if (graphMode === "Days30") {
      console.log("Now processing Days30");
      deleteLastTimer();
      setTimerId(0);
      pullBEData(graphMode,currDeviceSerial);
    }
  }, [graphMode]);

  function chartPlace() {
    //
    // Chart #1 - Elevator Status
    //
    var chartDom = document.getElementById("m_area_chart");
    var myChart = echarts.init(chartDom);
    var option;
    const colors = ['blue', 'red', 'green'];
    option = chartOption3;
    console.log("dashData1.ctTempXaxis",dashData1.ctTempXaxis);
    if (option != null && option.xAxis != null && option.xAxis.length > 0 && dashData1.ctTempXaxis && dashData1.ctTempXaxis.length > 0) {
      //  console.log("current xAxis1",option.xAxis[0].data);
       option.xAxis[0].data = dashData1.ctTempXaxis;
      //  console.log("current xAxis2",dashData1.ctTempXaxis);
       if (option.xAxis.length > 1) {
          option.xAxis[1].data = dashData1.ctTempXaxis;
       }       
    }
    if (option != null && option.series != null && option.series.length > 0) {
       // console.log("CT brakeTemps",dashData1.latestCTBMETemps);
       // console.log("CT motorTemps",dashData1.latestCTMotorTemps);
       option.series[0].data = dashData1.latestCTBMETemps;
       option.series[0].name = "Car Top Temperature";
       if (option.series.length > 1) {
          option.series[1].data = dashData1.latestCTMotorTemps;
       }
       option.xAxis[0].axisPointer.label.formatter = function (params) {
        return (
          'Car Top Temp ' +
          params.value +
          (params.seriesData.length ? '：' + params.seriesData[0].data : '')
        );
      };
    }
    option && myChart.setOption(option);
    //
    // Chart #2 - Elevator Pressure
    //
    var chartDom2 = document.getElementById("m_area_chart2");
    var myChart2 = echarts.init(chartDom2);
    var option2;
    option2 = chartOption4;
    // console.log("dashData1.ctPressureXaxis",dashData1.ctPressureXaxis);
    if (option2 != null && option2.xAxis != null && option2.xAxis.length > 0 && dashData1.ctPressureXaxis && dashData1.ctPressureXaxis.length > 0) {
       option2.xAxis[0].data = dashData1.ctPressureXaxis;
    }
    if (option2 != null && option2.series != null && option2.series.length > 0) {
       option2.series[0].data = dashData1.latestCTBMEPressure;
       option2.series[0].name = "Car Top Pressure";
       option2.xAxis[0].axisPointer.label.formatter = function (params) {
        return (
          'Pressure ' +
          params.value +
          (params.seriesData.length ? '：' + params.seriesData[0].data : '')
        );
      };
    }
    option2 && myChart2.setOption(option2);
    //
    // Chart #3 - Elevator Humidity
    //
    var chartDom3 = document.getElementById("m_area_chart3");
    var myChart3 = echarts.init(chartDom3);
    var option3;
    option3 = chartOption4;
    // console.log("dashData1.ctHumidityXaxis",dashData1.ctHumidityXaxis);
    if (option3 != null && option3.xAxis != null && option3.xAxis.length > 0 && dashData1.ctHumidityXaxis && dashData1.ctHumidityXaxis.length > 0) {
       option3.xAxis[0].data = dashData1.ctHumidityXaxis;
    }
    if (option3 != null && option3.series != null && option3.series.length > 0) {
       option3.series[0].data = dashData1.latestCTBMEHumidity;
       option3.series[0].name = "Car Top Humidity";
       option3.xAxis[0].axisPointer.label.formatter = function (params) {
        return (
          'Humidity ' +
          params.value +
          (params.seriesData.length ? '：' + params.seriesData[0].data : '')
        );
      };
    }
    option3 && myChart3.setOption(option3);
    //
    // Chart #4 - Elevator ADXLXYZ
    //
    var chartDom4 = document.getElementById("m_area_chart4");
    var myChart4 = echarts.init(chartDom4);
    var option4;
    option4 = chartOption4;
    // console.log("dashData1.latestCTAdxlxyz",dashData1.latestCTAdxlxyz);
    if (option4 != null && option4.xAxis != null && option4.xAxis.length > 0 && dashData1.ctAdxLxyzXaxis && dashData1.ctAdxLxyzXaxis.length > 0) {
       option4.xAxis[0].data = dashData1.ctAdxLxyzXaxis;
    }
    if (option4 != null && option4.series != null && option4.series.length > 0) {
       option4.series[0].data = dashData1.latestCTAdxlxyz;
       option4.series[0].name = "Ride Comfort";
       option4.xAxis[0].axisPointer.label.formatter = function (params) {
        return (
          'Comfort ' +
          params.value +
          (params.seriesData.length ? '：' + params.seriesData[0].data : '')
        );
      };
    }
    option4 && myChart4.setOption(option4);
  };

  function handleResetButton(isTrip) {
    console.log("handleResetButton for deviceSerial",deviceSerial);
    var sessionData = getLastSession();
    // console.log("Last Session",sessionData);
    resetDevice(sessionData.id,deviceSerial,isTrip).then(resp => {
      console.log("resetDevice resp",resp);
      if (isTrip)
        alert("device trip done");
      else
        alert("device reset done"); 
    })
    .catch(err2 => {
      console.log("handleResetButton failed",err2);          
    });

  }

  function handleGraphModeChange(newMode) {
    console.log("handleGraphModeChange", newMode);
    setGraphMode(newMode);
  }

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            {dashData1 && 
            <PageHeader
              HeaderText="Tabs"
              Breadcrumb={[
                { name: "Home", navigate: "" },
                { name: "Elevator Status", navigate: "" },
              ]}
              LastUpdatedDate={dashData1.lastUpdatedDateTime} 
              deviceSerial={currDeviceSerial}
              callback={deviceSerialChanged}
              />
            }
            <div className="row clearfix">
              <div className="col-lg-6 col-md-12">
                <div className="card">
                  <div className="header d-flex justify-content-between">
                    <h2>Car Top Status</h2>
                    <div style={{display:"flex",gap:"10px"}}>
                      <button className={`btn ${graphMode === "Live" ? "btn-outline-success" : "btn-outline-primary"}`}   onClick={() => handleGraphModeChange('Live')} type="button">Live</button>
                      <button className={`btn ${graphMode === "Weekly" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Weekly')} type="button">Weekly</button>
                      <button className={`btn ${graphMode === "Days15" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days15')} type="button">15-Days</button>
                      <button className={`btn ${graphMode === "Days30" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days30')} type="button">Monthly</button>
                    </div>
                  </div>
                  <div className="body gender-overview" id="refreshDash1">
                    <h5>
                      <span className="m-r-50">
                        <strong style={{color:"blue",fontSize:"16px"}}>Car Top Temperature (°C)</strong> : {dashData1 && dashData1.currentCTBMETemp}
                      </span>
                      <span className="m-r-50">
                        <strong style={{color:"red",fontSize:"16px"}}>Motor Temperature (°C)</strong> : {dashData1 && dashData1.currentCTMotorTemp}
                      </span>
                    </h5>
                    <div id="m_area_chart" style={{ height: 300 }}></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="card">
                <div className="header d-flex justify-content-between">
                    <h2>Car Top Pressure</h2>
                    <div style={{display:"flex",gap:"10px"}}>
                      <button className={`btn ${graphMode === "Live" ? "btn-outline-success" : "btn-outline-primary"}`}   onClick={() => handleGraphModeChange('Live')} type="button">Live</button>
                      <button className={`btn ${graphMode === "Weekly" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Weekly')} type="button">Weekly</button>
                      <button className={`btn ${graphMode === "Days15" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days15')} type="button">15-Days</button>
                      <button className={`btn ${graphMode === "Days30" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days30')} type="button">Monthly</button>
                    </div>
                  </div>
                  <div className="body gender-overview" id="refreshDash2">
                    <h5 style={{textAlign:"center"}}>
                      <span className="m-r-50">
                        <strong style={{color:"blue",fontSize:"16px"}}>Car Top Pressure (hPa)</strong> : {dashData1 && dashData1.currentCTBMEPressure}
                      </span>
                    </h5>
                    <div id="m_area_chart2" style={{ height: 300 }}></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-6 col-md-12">
                <div className="card">
                <div className="header d-flex justify-content-between">
                    <h2>Car Top Humidity</h2>
                    <div style={{display:"flex",gap:"10px"}}>
                      <button className={`btn ${graphMode === "Live" ? "btn-outline-success" : "btn-outline-primary"}`}   onClick={() => handleGraphModeChange('Live')} type="button">Live</button>
                      <button className={`btn ${graphMode === "Weekly" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Weekly')} type="button">Weekly</button>
                      <button className={`btn ${graphMode === "Days15" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days15')} type="button">15-Days</button>
                      <button className={`btn ${graphMode === "Days30" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days30')} type="button">Monthly</button>
                    </div>
                  </div>
                  <div className="body gender-overview" id="refreshDash3">
                     <h5 style={{textAlign:"center"}}>
                      <span className="m-r-50">
                        <strong style={{color:"blue",fontSize:"16px"}}>Car Top Humidity (%)</strong> : {dashData1 && dashData1.currentCTBMEHumidity}
                      </span>
                    </h5>
                    <div id="m_area_chart3" style={{ height: 300 }}></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="card">
                <div className="header d-flex justify-content-between">
                    <h2>Ride Comfort</h2>
                    <div style={{display:"flex",gap:"10px"}}>
                      <button className={`btn ${graphMode === "Live" ? "btn-outline-success" : "btn-outline-primary"}`}   onClick={() => handleGraphModeChange('Live')} type="button">Live</button>
                      <button className={`btn ${graphMode === "Weekly" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Weekly')} type="button">Weekly</button>
                      <button className={`btn ${graphMode === "Days15" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days15')} type="button">15-Days</button>
                      <button className={`btn ${graphMode === "Days30" ? "btn-outline-success" : "btn-outline-primary"}`} onClick={() => handleGraphModeChange('Days30')} type="button">Monthly</button>
                    </div>
                  </div>
                  <div className="body gender-overview" id="refreshDash4">
                    <h5 style={{textAlign:"center"}}>
                      <span className="m-r-50">
                        <strong style={{color:"blue",fontSize:"16px"}}>Ride Comfort</strong> : {dashData1 && dashData1.currentCTAdxlxyz}
                      </span>
                    </h5>
                    <div id="m_area_chart4" style={{ height: 300 }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}
